import { render, staticRenderFns } from "./lookListTableKehu.vue?vue&type=template&id=50fa4944&scoped=true"
import script from "./lookListTableKehu.vue?vue&type=script&lang=js"
export * from "./lookListTableKehu.vue?vue&type=script&lang=js"
import style0 from "./lookListTableKehu.vue?vue&type=style&index=0&id=50fa4944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa4944",
  null
  
)

export default component.exports